import React, { Component } from 'react';

class BottomLinks extends Component {

    openChat() {
        window.open(`${process.env.REACT_APP_CHAT_URL}?ReqSkill=Chat_EBUSales`, 'chat', 'resizable=no,status=no,location=no,toolbar=no,menubar=no,fullscreen=no,scrollbars=no,dependent=no,width=480,height=600')
        return false;
    }

    render() {
        return (
            <div className="bottom-help-row">
                <span className="no-cursor">Need some help?</span>
                <span>
                    <svg focusable="false" aria-hidden="true" className="icon colored"> <use
                        xlink="http://www.w3.org/1999/xlink" href="#icon-chat"/></svg>
                    <a href="#" onClick={this.openChat} className="colored">Chat to us online</a>
                    <svg focusable="false" aria-hidden="true" className="icon colored small-icon"><use
                        xlink="http://www.w3.org/1999/xlink" href="#icon-chevron-right"/></svg>
                </span>
                <span className="no-cursor">
                    <svg focusable="false" aria-hidden="true" className="icon colored"> <use
                        xlink="http://www.w3.org/1999/xlink" href="#icon-landline-or-call"/></svg>
        Or call us on <strong>082 1960</strong>
                </span>
            </div>
        );
    }

}

export default BottomLinks;
